<div class="loading-indicator" *ngIf="showLoader">
  <div
    class="spinner-border text-primary"
    style="width: 3rem; height: 3rem;"
    role="status"
  >
    <span class="sr-only">Loading...</span>
  </div>
</div>
